import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

export function Section({ title, action, children, testid }) {
  return (
    <div data-testid={testid}>
      <div className="flex items-center justify-between mb-3 pb-2 border-b border-[#E8E4D9]">
        <h2 className="text-xs font-bold text-zinc-500 uppercase tracking-widest">{title}</h2>
        {action}
      </div>
      {children}
    </div>
  );
}

export function Field({ label, required, hint, span = 1, icon, children }) {
  return (
    <div className={span === 2 ? "md:col-span-2" : ""}>
      <div className="flex items-center gap-1 mb-1">
        <label className="text-xs font-medium text-zinc-700 flex-1">
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
        {icon}
      </div>
      {children}
      {hint && <p className="mt-1 text-[11px] text-zinc-500 leading-snug">{hint}</p>}
    </div>
  );
}

export function TextField({ mono, testid, className = "", readOnly, ...props }) {
  return (
    <input
      data-testid={testid}
      readOnly={readOnly}
      className={`w-full h-10 px-3 rounded-md border text-sm outline-none transition-colors ${mono ? "font-mono" : ""} ${
        readOnly
          ? "border-[#E8E4D9] bg-[#F5F2EA] text-[#737373] cursor-not-allowed"
          : "border-[#E8E4D9] bg-white focus:border-zinc-900 focus:ring-2 focus:ring-zinc-900/10"
      } ${className}`}
      {...props}
    />
  );
}

export function SelectField({ testid, children, ...props }) {
  return (
    <select
      data-testid={testid}
      className="w-full h-10 px-3 rounded-md border border-[#E8E4D9] bg-white text-sm focus:border-zinc-900 outline-none transition-colors"
      {...props}
    >
      {children}
    </select>
  );
}

export function PdfEmbed({ url, token }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let revoked = false;
    let objectUrl = null;
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob())
      .then((blob) => {
        if (revoked) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      });
    return () => {
      revoked = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url, token]);
  if (!src) {
    return (
      <div className="flex-1 grid place-items-center text-zinc-500">
        <Loader2 className="w-4 h-4 animate-spin" />
      </div>
    );
  }
  return <iframe src={src} title="PDF" className="flex-1 w-full h-full" />;
}
